export default "__VITE_ASSET__DIPIv1dl__"